// extracted by mini-css-extract-plugin
module.exports = {"square":"Persona_square__2KD2W"};